import { HasMaxLengthValidation, IsRequiredValidation } from "@generation/form";

export const IsRequiredValidationFactory = () => new IsRequiredValidation();

export const HasMaxLengthValidationFactory = (maxLength?: number) =>
  new HasMaxLengthValidation(
    maxLength || 50,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld, u mag maximaal ${
        maxLength || 50
      } karakters invullen.`,
    true
  );
